export default {
  title: "GPS Tracker プロビジョニング管理",
  columns: {
    provisioningStatus: "プロビジョニング状態",
    failureReason: "失敗理由",
    lastExecutedAt: "最終実行",
    executedBy: "実行者",
    actions: "操作",
  },
  categories: {
    not_executed: "未実行",
    running: "実行中",
    failed: "失敗",
    done: "完了",
  },
  failureReasons: {
    config_failed: "Config",
    cert_failed: "証明書",
    timeout: "タイムアウト",
    topic_failed: "トピック",
    error: "エラー",
  },
  filters: {
    numberPlate: "設置車両",
  },
  statusChips: {
    topic_pending: "進行中（トピック待ち）",
  },
  tooltips: {
    bulkScope: "「全未実行」「全失敗」は絞り込み表示に関係なく全件が対象です。",
    topicPending: "config・証明書の適用は完了しています。トピック設定は MQTT retain で保持されており、端末がオンラインになった時に自動で適用されます。出荷前にデバイスIDを変更した場合は「再実行」で反映してください。",
  },
  buttons: {
    executeSelected: "選択した {count}件を実行",
    forceRerunSelected: "選択した {count}件を強制再実行",
    executeAllNotExecuted: "全未実行をまとめて実行 ({count})",
    retryAllFailed: "全失敗をまとめて再実行 ({count})",
    refreshStatus: "状態更新",
    refreshDone: "{time} 更新完了",
    execute: "実行",
    retry: "再実行",
    forceRerun: "強制再実行",
  },
  notice: {
    deviceManagementPrefix: "デバイスの登録・変更は",
    deviceList: "デバイス一覧",
    deviceManagementSuffix: "で行ってください。",
  },
  messages: {
    selectDevice: "デバイスを選択してください。",
    noBulkTargets: "対象のデバイスがありません。",
    executed: "プロビジョニングを実行しました。",
    executeFailed: "プロビジョニングの実行に失敗しました。",
    executeSkipped: "{count} 台は完了または実行中のためスキップされました。",
    executePartiallyFailed: "{count} 台のプロビジョニング実行に失敗しました。",
    fetchFailed: "プロビジョニング状態の取得に失敗しました。",
    noData: "該当するデバイスがありません。",
  },
  modal: {
    title: "プロビジョニングの確認",
    forceTitle: "強制再実行の確認",
    bodySelected: "選択した {count} 台のGPS Trackerデバイスをプロビジョニングします。よろしいですか？",
    bodyCategory: "「{category}」のGPS Trackerデバイス {count} 台をすべてプロビジョニングします。よろしいですか？",
    skipNotice: "うち {count} 台は完了または実行中のためスキップされます。強制的にやり直す場合は「強制再実行」を使ってください。",
    forceWarning: "証明書を再発行するため、端末が最大2時間AWSに接続できません。",
    forceRunningWarning: "実行中の {count} 台は処理が中断され、最初からやり直しになります。",
    targetIds: "対象デバイスID:",
    cancel: "キャンセル",
    execute: "実行",
  },
}
